<template>
	<vue-event-form></vue-event-form>
</template>

<script>
import VueEventForm from './Form.vue'
export default {
	components: {
		VueEventForm,
	},
}
</script>
